import { render } from "./ChurchDashboard.vue?vue&type=template&id=3a4edb28"
import script from "./ChurchDashboard.vue?vue&type=script&lang=js"
export * from "./ChurchDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__